export default __webpack_public_path__ + "static/usd-b80f6486c35f7c3fc3edbe9a8875b5df.svg";